import { useState } from "react";
import Button from "../../../common/Button";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../../store/notifications";
import { downloadPDFVariant, generateGlobalDownloadPDF } from "../../../../lib/fetchApi";

export default function GeneratePDFDownload({children, url, boxStyle, fileName, variant, disabled, modalWarning, loaderType, onDownloadSuccess}) {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 


    async function generatePDFHandler() {
            
        if (!disabled) {
            if (modalWarning) {
                modalWarning()
            } else {
                setLoading(true)
                let response 

                if (variant) {
                    response = await downloadPDFVariant(userToken, activeCase.case.id, url)
                } else {
                    response = await generateGlobalDownloadPDF(userToken, activeCase.case.id, url)
                }

                if (response && response.errorMessage) {
                    dispatch(notificationActions.setError(response))     
                } else {   
                    const fileURL = URL.createObjectURL(response)
                    
                    // force download, if not the file needs to be saved firt in the app and then generate a link...
                    const a = document.createElement("a");
                    a.href = fileURL;
                    a.download = fileName ? fileName : "download_file.pdf"; 
                    a.click();

                    if (onDownloadSuccess) {
                        await onDownloadSuccess()
                    }
                }

                setLoading(false)
            }
        }

    }

    return <Button click={generatePDFHandler} isLoading={loading} btnStyle={boxStyle} isDisabled={disabled} loaderType={loaderType}>{children}</Button>
}